const URL_UTP = process.env.REACT_APP_URL_UTP;
const URL_API = process.env.REACT_APP_URL_API;
const URL_KC_HHOST = process.env.REACT_APP_URL_KC_HHOST;
const LINKEDIN_API_SERVER = URL_API + '/api/linkedin/token';
const LINKEDIN_CLIENT_ID = process.env.REACT_APP_LINKEDIN_CLIENT_ID;
const LINKEDIN_CLIENT_SECRET = process.env.REACT_APP_LINKEDIN_CLIENT_SECRET;
const LINKEDIN_CALLBACK_URL = process.env.REACT_APP_LINKEDIN_CALLBACK_URL; //Se deja en blanco para que de forma automatica recoja el dominio donde se desplegó el compilado.Ejemplo: dominio.com/linkedin.

const GOOGLE_ID_API_LOGIN = process.env.REACT_APP_GOOGLE_ID_API_LOGIN;

export const APIS = {
    linkedin_api_server: `${LINKEDIN_API_SERVER}`,
    linkedin_client_id: `${LINKEDIN_CLIENT_ID}`,
    linkedin_client_secret: `${LINKEDIN_CLIENT_SECRET}`,
    linkedin_callback_url: `${LINKEDIN_CALLBACK_URL}`,
    google_id_api_login: `${GOOGLE_ID_API_LOGIN}`,
    crm_validate: `${URL_API}/api/crm/validate`,
    valida_dni: `${URL_UTP}/Persona/VALIDA_DNI`,
    datos_dni: `${URL_UTP}/Persona/DATOS_DNI`,
    users: `${URL_API}/api/users`,
    user: `${URL_API}/api/user`,
    userByMail: `${URL_API}/api/userByEmail/`,
    submissionByEmail: `${URL_API}/api/submissionByEmail/`,
    submissionDelete: `${URL_API}api/submissionLD/`,
    submissionStateByEmail: `${URL_API}/api/getSubmissionState/`,
    sendEmailInscripcion: `${URL_API}/api/sendEmailInscripcion/`,
    tiposDocumento: `${URL_API}/api/tiposDocumento`,
    documento: `${URL_API}/api/documento`,
    tiposDocumentoIdentidad: `${URL_API}/api/tiposDocumentoIdentidad`,
    generos: `${URL_API}/api/generos`,
    gradosAcademicos: `${URL_API}/api/gradosAcademicos`,
    estadoCivil: `${URL_API}/api/estadoCivil`,
    paises: `${URL_API}/api/paises`,
    institucionesEducativas: `${URL_API}/api/institucionesEducativas`,
    institucionesEducativasNombre: `${URL_API}/api/institucionesEducativasNombre`, // NO CARGA
    institucionEducativa: `${URL_API}/api/institucionEducativa/`, // NO CARGA
    institucionEducativaByPS: `${URL_API}/api/institucionEducativaByPS/`, // NO CARGA
    rubrosEmpresa: `${URL_API}/api/rubrosEmpresa`,
    tiposIngreso: `${URL_API}/api/tiposIngreso`,
    tiposComprobante: `${URL_API}/api/tiposComprobante`,
    formasPago: `${URL_API}/api/formasPago`,
    parametro: `${URL_API}/api/parametro`,
    idiomas: `${URL_API}/api/idiomas`,
    nivelesIdioma: `${URL_API}/api/nivelesIdioma`,
    submission: `${URL_API}/api/submission`,
    submissionTypes: `${URL_API}/api/submissionTypes`,
    submissionTypesProgramas: `${URL_API}/api/programas/submissionType/`,
    departamentos: `${URL_API}/api/departamentos`,
    provincias: `${URL_API}/api/provincias/`,
    distritos: `${URL_API}/api/distritos/`,
    tiposVivienda: `${URL_API}/api/tiposVivienda`,
    estudioAcademico: `${URL_API}/api/estudioAcademico`,
    gradosEstudios: `${URL_API}/api/gradosEstudios`,
    gradosEstudiosAll: `${URL_API}/api/gradosEstudios/all`,
    estudioAcademicoByIdSubmission: `${URL_API}/api/estudioAcademicoByIdSubmission/`,
    datoLaboralByIdSubmission: `${URL_API}/api/datoLaboralByIdSubmission/`,
    datoLaboral: `${URL_API}/api/datoLaboral`,
    documentoByIdSubmission: `${URL_API}/api/documentoByIdSubmission/`,
    downloadFile: `${URL_API}/api/documento/downloadFile/`,
    clonaDocumentos: `${URL_API}/api/clona/documentos`,
    cartaPresentacion: `${URL_API}/api/create/carta/presentacion/`,
    cartaPresentacionGenera: `${URL_API}/api/documento/generate/carta/presentacion/`,
    ddjjGenera: `${URL_API}/api/documento/generate/ddjj/financiamiento/`,
    cuentaCostosbyGradoAcademico: `${URL_API}/api/cuentaCostos/byGradoAcademico/`,
    pdfddjj: `${URL_API}/api/pdf-ddjj/`,
    campanas: `${URL_API}/api/campanas`,
    programaByCampanaId: `${URL_API}/api/programaByCampanaId/`,
    kcLoginData: {
        client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID,
        username: process.env.REACT_APP_KEYCLOAK_USERNAME,
        password: process.env.REACT_APP_KEYCLOAK_PASSWORD,
        grant_type: process.env.REACT_APP_KEYCLOAK_GRANT_TYPE,
        scope: process.env.REACT_APP_KEYCLOAK_SCOPE
    },
    kcLogin: `${URL_KC_HHOST}/auth/realms/Xpedition/protocol/openid-connect/token`,
    kcUserProfile: `${URL_KC_HHOST}/auth/realms/Xpedition/protocol/openid-connect/userinfo`,
}